/* eslint-disable arrow-body-style */
import React, { useMemo, useRef } from 'react';
import FilterSelect from '@/pages/dashboard/components/FilterSelect';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';
import { IVersionProps } from '../_type';
import { TOptionsItem } from '@/pages/dashboard/components/FilterSelect/types';
import { getName } from '@home/utils/common';
import classNames from 'classnames';

/**
 * 版本筛选器组件，用于选择和管理版本信息
 * @param props - 组件属性
 * @param props.options - 可选版本列表选项
 * @param props.defaultVal - 默认选中的版本值数组
 * @param props.locale - 国际化配置
 * @param props.onChange - 版本选择变更时的回调函数
 * @param props.showBubble - 是否显示气泡提示
 * @param props.bubbleContent - 气泡提示内容
 * @param props.name - 筛选器名称
 * @param props.tooltip - 提示信息
 * @returns 版本筛选器React组件
 */
const VersionFilter = (props: IVersionProps) => {
  const {
    options,
    value,
    locale,
    onChange,
    isEN,
    showBubble = false,
    bubbleContent,
    name,
    tooltip,
    onConfirm,
    showSlectedNum = 1,
    isRevertToLastSelection = true,
    buttonDesName = getName(isEN, 'Latest', '最新'),
    // onReset,
    ...resetProps
  } = props;
  // const [version, setVersion] = useState<string[]>(defaultVal || []);
  const bindClassName = useRef(Date.now().toString(36));

  const renderSelected = (selectedOptions: Array<TOptionsItem>) => {
    const len = selectedOptions?.length;
    if (len > showSlectedNum) return selectedOptions?.length;
    return selectedOptions?.map((item, index) => {
      
      const isFirst = item?.value === options?.[0]?.value && len === 1;
      const describe = index === 0 ? buttonDesName : '';
      // 获取名称，过滤html代码
      const text = item?.text?.replace?.(/<[^>]+>/gim, '');
      // 统一有图标则展示到选择框内
      return <>
        <span>{item?.icon && <img src={item.icon} />} {text}{index !== selectedOptions.length - 1 && ','}</span>
        {
          isFirst && <span className='dbd-benchmark-version-filter-item-des'>
            &nbsp;{describe}
          </span>
        }
      </>;
    });
  };

  // 使用 useMemo 缓存 selectedOptions
  const selectedOptions = useMemo(() => {
    if (!options || !value) return [];
    return options.filter((item) => value.includes(item.value));
  }, [options, value]);


  return (
    <div className='dbd-GTDR-version-select-box'>
      <CommonBubble
        className={"dbd-version-filter-bubble"}
        content={showBubble ? bubbleContent : ''}
        overlayClassName='dbd-version-filter-bubble-box'
        visible={true}
        escapeWithReference
        flipped={false}
        destroyOnClose={false}
      >
        <FilterSelect
          matchButtonWidth
          // `dbd-GTDR-version-select version-${bindClassName.current}`
          className={classNames(
            'dbd-GTDR-version-select',
            `version-${bindClassName.current}`,
            {'dbd-GTDR-version-select-error': showBubble}
          )}
          boxClassName='dbd-GTDR-version-select-wrap-box'
          escapeWithReference={true}
          options={options}
          value={value}
          showSelectAll={false}
          searchable={false}
          // showSlectedNum={showSlectedNum}
          locale={locale}
          onChange={onChange}
          name={name}
          tooltip={tooltip}
          onConfirm={onConfirm}
          isRevertToLastSelection={isRevertToLastSelection}
          popupContainer={ () => document.querySelector(`.version-${bindClassName.current}`)}
          button={
            () => {
              return <div className={`db-filter-select-button`}>
                <span className="db-filter-select-button-text">
                  {name ? name : ''}
                </span>
                <span className="db-filter-select-button-value">
                  {selectedOptions?.length ? renderSelected(selectedOptions) : ''}
                </span>
              </div>;
            }
          }
          // onReset={onReset}
          {...(resetProps || {})}
        />
      </CommonBubble>
    </div>
  );
};

export default VersionFilter;
